(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gb-home-recent"] && !Shopify.designMode) return;
  try {
    
const recentRoots = document.querySelectorAll('[data-gb-home-recent]');

const loadRecentSuits = async (root) => {
  const mount = root.querySelector('[data-gb-home-recent-mount]');
  const searchUrl = root.dataset.searchUrl;
  const sectionId = root.dataset.sectionId;
  if (!mount || !searchUrl || !sectionId) return;

  let ids = [];
  try {
    const stored = JSON.parse(localStorage.getItem('viewedProducts') || '[]');
    if (Array.isArray(stored)) {
      ids = stored.filter((id) => /^\d+$/.test(String(id))).slice(0, 4);
    }
  } catch {
    return;
  }

  if (ids.length === 0) return;

  const url = new URL(searchUrl, window.location.origin);
  url.searchParams.set('q', ids.map((id) => `id:${id}`).join(' OR '));
  url.searchParams.set('type', 'product');
  url.searchParams.set('section_id', sectionId);

  try {
    const response = await fetch(url, { credentials: 'same-origin' });
    if (!response.ok) return;
    const html = await response.text();
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const source = parsed.querySelector('[data-gb-recent-source]');
    if (!source || !source.querySelector('a')) return;
    mount.replaceChildren(source);
    root.hidden = false;
  } catch {
    return;
  }
};

recentRoots.forEach((root) => {
  loadRecentSuits(root);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
